import * as React from 'react';
import { SvgIcon } from '../svg-icon';
import heart from '../../assets/svg/heart.svg';
import * as style from './heart-animation.less';
import { isFunction } from '../../../Shared/utils/is-function';

export const HeartAnimation = ({ onMount }: { onMount?: () => void }) => {
	React.useEffect(() => {
		if (isFunction(onMount)) {
			onMount();
		}
	}, []);
	return (
		<div className={style.heartContainer}>
			<div className={style.burst}>
				{
					// array of 12 empty items so I can create 12 bursts
					['', '', '', '', '', '', '', '', '', '', '', ''].map((item, index) => (
						<div className={style.burstRay} key={`burst_${index}`} />
					))
				}
			</div>
			<div className={style.circle}>
				<SvgIcon svg={heart} className={style.heart} />
			</div>
		</div>
	);
};
